import call from "./call";

const MANAGER_URL = '1xvxUSVm2E';

const Manager = {
    get: () => call(MANAGER_URL).then(results => results && results.length > 0 && results[0])
};

export default Manager;